import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { ServerErrorModalComponent } from '@app/utils/components/server-error-modal/server-error-modal.component';
import { FeedbackModalComponent } from '@app/utils/components/feedback-modal/feedback-modal.component';
import { AppFooterComponent } from '@app/shared/components/app-footer/app-footer.component';
import { LoadingSpinnerComponent } from '@app/shared/components/loading-spinner/loading-spinner.component';
import { GlobalLoaderService } from '@app/utils/services/global-loader.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ServerErrorModalComponent,
    FeedbackModalComponent,
    AppFooterComponent,
    LoadingSpinnerComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'PLP_UNE_F_ONBOARDING';

  private readonly router = inject(Router);
  protected readonly loader = inject(GlobalLoaderService);

  constructor() {
    // Mostrar el loader global durante cada transición de ruta. Las páginas del
    // onboarding ya no necesitan un spinner propio para la navegación; el modal
    // aparece entre NavigationStart y el término (End/Cancel/Error).
    this.router.events
      .pipe(takeUntilDestroyed())
      .subscribe(event => {
        if (event instanceof NavigationStart) {
          this.loader.show();
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.loader.hide();
        }
      });
  }
}
